import { render } from "./UploadCSV.vue?vue&type=template&id=555bcfd4&scoped=true"
import script from "./UploadCSV.vue?vue&type=script&lang=js"
export * from "./UploadCSV.vue?vue&type=script&lang=js"

import "./UploadCSV.vue?vue&type=style&index=0&id=555bcfd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555bcfd4"]])

export default __exports__